import { render, staticRenderFns } from "./ErrorForm.vue?vue&type=template&id=1c0c3f0b&scoped=true&"
import script from "./ErrorForm.vue?vue&type=script&lang=js&"
export * from "./ErrorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c3f0b",
  null
  
)

export default component.exports